import { EventEmitter } from '@angular/core';
import { RoiReport, RoiSetting } from '../../../../../models/measure/roi-report';
import { CommonConstant } from '../../../../app.constants';
import { ReportSectionEnum } from '../../../../../models/measure/report';
import { MeasureService } from '../../../../services/measure/measure.service';
import { UserService } from '../../../../services/user.service';
import { AchooPopupComponent } from '../../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../../services/modal/modal.service';
import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { TranslateService } from '@ngx-translate/core';
var RoiReportComponent = /** @class */ (function () {
    function RoiReportComponent(userService, measureService, modalService, pdfService, translate) {
        this.userService = userService;
        this.measureService = measureService;
        this.modalService = modalService;
        this.pdfService = pdfService;
        this.translate = translate;
        this.changePage = new EventEmitter();
        this.roiSetting = new RoiSetting();
        // curent page number of ROI report, start with 1
        this.currentPage = 1;
    }
    RoiReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.measureService.loadRoiSetting(this.userService.getCompanyId()).subscribe(function (res) {
            if (res) {
                _this.roiSetting = res;
            }
        });
    };
    RoiReportComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.pdfService.imagedLoadedTrigger.subscribe(function (data) {
            if (data.component === "" + RoiReportComponent.COMPONENT_NAME + _this.pageIndex
                && data.currentCounter === _this.roiReport.datas.length) {
                _this.pdfService.incrementNumberReportReady("" + RoiReportComponent.COMPONENT_NAME + _this.pageIndex);
            }
        });
    };
    RoiReportComponent.prototype.openSetting = function () {
        this.modalService.openInCenter(this.roiSettingPopup, undefined, 'roi-settings-modal');
    };
    RoiReportComponent.prototype.closeSetting = function () {
        this.modalService.close();
    };
    RoiReportComponent.prototype.isCurrencyField = function (colName) {
        return colName === CommonConstant.CURRENCY_COL;
    };
    Object.defineProperty(RoiReportComponent.prototype, "roiValue", {
        get: function () {
            if (!this.roiReport || !this.roiReport.kpis) {
                return null;
            }
            return this.roiReport.kpis.find(function (kpi) { return kpi.name.toLowerCase() === CommonConstant.ROI_COL.toLowerCase(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "postKpi", {
        get: function () {
            if (!this.roiReport || !this.roiReport.kpis) {
                return null;
            }
            return this.roiReport.kpis.find(function (kpi) { return kpi.name.toLowerCase() === CommonConstant.POSTS_COL.toLowerCase(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "influencersKpi", {
        get: function () {
            if (!this.roiReport || !this.roiReport.kpis) {
                return null;
            }
            return this.roiReport.kpis.find(function (kpi) { return kpi.name.toLowerCase() === CommonConstant.INFLUENCERS_COL.toLowerCase(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "impressionKpi", {
        get: function () {
            if (!this.roiReport || !this.roiReport.kpis) {
                return null;
            }
            return this.roiReport.kpis.find(function (kpi) { return kpi.name.toLowerCase() === CommonConstant.IMPRESSIONS_COL.toLowerCase(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "reachKpi", {
        get: function () {
            if (!this.roiReport || !this.roiReport.kpis) {
                return null;
            }
            return this.roiReport.kpis.find(function (kpi) { return kpi.name.toLowerCase() === CommonConstant.REACH_COL.toLowerCase(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "currency", {
        get: function () {
            var _this = this;
            if (!this.roiReport) {
                return 0;
            }
            var currency = this.roiReport.kpis.filter(function (kpi) { return _this.isCurrencyField(kpi.name); })[0];
            return currency ? currency.value : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "roiKpiList", {
        /**
         * Currency value will not display in ROI KPI section
         * @returns {RoiReportKpi[]}
         */
        get: function () {
            var _this = this;
            if (!this.roiReport) {
                return [];
            }
            return this.roiReport.kpis.filter(function (kpi) { return !_this.isCurrencyField(kpi.name); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "haveNoData", {
        get: function () {
            if (!this.roiReport || !this.roiReport.datas) {
                return true;
            }
            return this.roiReport.datas.length === 0 && (!this.pageIndex || this.pageIndex === 0);
        },
        enumerable: true,
        configurable: true
    });
    RoiReportComponent.prototype.onChangePage = function (evt) {
        this.currentPage = evt;
        this.changePage.emit({
            reportSection: ReportSectionEnum.ROI_REPORT,
            criteriaChange: { page_no: evt }
        });
    };
    Object.defineProperty(RoiReportComponent.prototype, "maxPage", {
        get: function () {
            if (!this.roiReport) {
                return 0;
            }
            var totalFullPage = Math.floor(this.roiReport.totalRow / this.numberOfItemPerPage);
            var hasPartialPage = (this.roiReport.totalRow % this.numberOfItemPerPage) > 0;
            return hasPartialPage ? totalFullPage + 1 : totalFullPage;
        },
        enumerable: true,
        configurable: true
    });
    RoiReportComponent.prototype.onSaveRoiSetting = function () {
        var _this = this;
        this.closeSetting();
        this.measureService.saveRoiSetting(this.roiSetting).subscribe(function (res) {
            // reload ROI report
            _this.changePage.emit({
                reportSection: ReportSectionEnum.ROI_REPORT,
                criteriaChange: {}
            });
        }, function (error) {
            _this.modalService.open(_this.errorNotification, null, true);
            _this.openSetting();
        });
    };
    RoiReportComponent.prototype.calculateIndex = function (index) {
        if (this.pageIndex) {
            if (this.pageIndex > 0) {
                return this.pageIndex * CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE + index - 1;
            }
            else {
                return this.pageIndex * CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE + index + 1;
            }
        }
        return (this.currentPage - 1) * this.numberOfItemPerPage + index + 1;
    };
    RoiReportComponent.prototype.findCountryCode = function (influencer) {
        return influencer.country ? influencer.country.code : CommonConstant.INTERNATION_COUNTRY_CODE;
    };
    RoiReportComponent.prototype.onLoadedAvatarImage = function () {
        this.pdfService.updateNumberImageLoaded("" + RoiReportComponent.COMPONENT_NAME + this.pageIndex);
    };
    Object.defineProperty(RoiReportComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "isExportingPdfReport", {
        get: function () {
            return this.pdfService.exportingPdf;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "listInfluencer", {
        get: function () {
            if (!this.roiReport || !Array.isArray(this.roiReport.datas)) {
                return [];
            }
            var startIndex = (this.currentPage - 1) * this.numberOfItemPerPage;
            return this.roiReport.datas.slice(startIndex, startIndex + this.numberOfItemPerPage);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "shouldShowHeader", {
        get: function () {
            return !this.pageIndex || this.pageIndex === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoiReportComponent.prototype, "roiValueColHeader", {
        get: function () {
            if (!this.roiReport || !this.roiReport.kpis) {
                return null;
            }
            var currencyValue = this.roiReport.kpis.find(function (kpi) { return kpi.name.toLowerCase() === CommonConstant.CURRENCY_COL.toLowerCase(); });
            var currencySign = '';
            switch (currencyValue.value) {
                case 0:
                    currencySign = CommonConstant.CURRENCY_SIGN.EURO;
                    break;
                case 1:
                    currencySign = CommonConstant.CURRENCY_SIGN.USD;
                    break;
                case 2:
                    currencySign = CommonConstant.CURRENCY_SIGN.DANISH_KRONE;
                    break;
                case 3:
                    currencySign = CommonConstant.CURRENCY_SIGN.NORWEGIAN_KRONER;
                    break;
                case 4:
                    currencySign = CommonConstant.CURRENCY_SIGN.SWEDISH_KRONA;
                    break;
                case 5:
                    currencySign = CommonConstant.CURRENCY_SIGN.POUND;
                    break;
            }
            return this.translate.instant('measure.roi_table.header.roi', { currencySign: currencySign });
        },
        enumerable: true,
        configurable: true
    });
    RoiReportComponent.COMPONENT_NAME = 'RoiReportComponent';
    return RoiReportComponent;
}());
export { RoiReportComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/content/roi-report/roi-report.component.ts.pre-build-optimizer.js